import isObjectEmpty from './is-object-empty';
import sendDataToNewrelic from '@stencil/send-data-to-new-relic';

const getBookingReviewLocalStorageData = ({
  onwardFlights,
  returnFlights = [],
  alternateTimeFlights = [],
  alternateLocationFlights = [],
  selectedFlight,
  source,
  destination,
  departure,
  arrival,
  passengers,
  domesticRoundTripCombo = null,
  domesticRoundTrip = false,
  travelType,
  airports,
  carriers,
  dates,
  aircrafts,
  discounts = [],
  ibp,
  terminalInfo,
  promotionText,
  multiIndex,
  refundability,
  brandIds,
  brandNames,
  discountFares,
  discountNames,
  discountMessages,
  paVal,
  messageValues,
  staticInformation = {},
  queryParam = '',
  isRoundTrip
}) => {
  try {
    let o = [];
    let r = [];
    if (selectedFlight.alternateTime) {
      o = alternateTimeFlights[selectedFlight.originalIndex];
    } else if (selectedFlight.alternateLocation) {
      o = alternateLocationFlights[selectedFlight.originalIndex];
    } else if (
      domesticRoundTrip &&
      domesticRoundTripCombo &&
      domesticRoundTripCombo.onwardIndex &&
      domesticRoundTripCombo.returnIndex
    ) {
      o = onwardFlights[domesticRoundTripCombo.onwardIndex];
      r = returnFlights[domesticRoundTripCombo.returnIndex];
      let onwardArr = onwardFlights[domesticRoundTripCombo.onwardIndex];
      if (onwardArr) {
        o = [{ ...onwardArr[0], i: domesticRoundTripCombo.onwardIndex }];
      }
      let returnArr = returnFlights[domesticRoundTripCombo.returnIndex];
      if (returnArr) {
        r = [{ ...returnArr[0], i: domesticRoundTripCombo.returnIndex }];
      }
    } else {
      o = onwardFlights[selectedFlight.originalIndex];
      if (!Array.isArray(o)) {
        o = [o];
      }
    }
    const bookData = {
      o: o && o[0] ? (o.length > 1 ? o : [o[0]]) : [],
      r: r && r[0] ? [r[0]] : [],
      a: airports,
      c: carriers,
      d: dates,
      g: discounts,
      i: ibp,
      t: terminalInfo,
      e: aircrafts,
      px: promotionText,
      m: multiIndex,
      w: refundability,
      mc: '',
      ...(selectedFlight?.bundleIndex !== null && typeof selectedFlight?.bundleIndex !== 'undefined'
        ? { onward_bundle_id: selectedFlight.bundleIndex }
        : null),
      ...(brandIds?.length > 0 ? { bi: brandIds } : null),
      ...(brandNames?.length > 0 ? { bn: brandNames } : null),
      ...(discountFares?.length > 0 ? { df: discountFares } : null),
      ...(discountNames?.length > 0 ? { dn: discountNames } : null),
      ...(discountMessages?.length > 0 ? { dm: discountMessages } : null),
      ...(paVal?.length > 0 ? { pa: paVal } : null),
      // ...(messageValues.length > 0 ? { mv: messageValues } : null),
      ...(isObjectEmpty(staticInformation) ? null : { si: staticInformation })
    };
    return {
      bookData,
      queryParam: 'air-' + queryParam,
      isRoundTrip,
      travelType,
      source,
      destination,
      departure,
      arrival,
      passengers
    };
  } catch (err) {
    sendDataToNewrelic('BookingReviewDataSelector', `Failed with error: ${err}`);
  }
};

export default getBookingReviewLocalStorageData;
